module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainAll"
  }, [_c('div', {
    staticClass: "screen-0 screenItem"
  }, [_c('div', {
    staticClass: "screenTop"
  }, [_c('div', {
    staticClass: "topcenter"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('el-button', {
    staticClass: "noSelectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('新闻动态')
      }
    }
  }, [_vm._v("新闻动态")]), _vm._v(" "), _c('el-button', {
    staticClass: "noSelectBtn",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('联系我们')
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('el-button', {
    staticClass: "noSelectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('产品介绍')
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('el-button', {
    staticClass: "selectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('首页')
      }
    }
  }, [_vm._v("首页")])], 1)]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "screen-1 screenItem"
  }, [_c('div', {
    staticClass: "mainTwoC"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "screen-4 screenItem"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "product-content-container"
  }, [_c('div', {
    staticClass: "product-content clearfix"
  }, [_c('img', {
    staticClass: "cooperation-content-img",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": require("@/assets/vpai.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.selectCity('产品介绍')
      }
    }
  })])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "screen-6",
    staticStyle: {
      "height": "300px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "page-bottom clearfix"
  }, [_c('div', {
    staticClass: "page-content-container clearfix"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "page-bottom-right clearfix"
  }, [_c('div', {
    staticClass: "page-bottom-right-content"
  }, [_c('div', {
    staticClass: "page-bottom-content-list"
  }, [_c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('首页')
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('产品介绍')
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('联系我们')
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('新闻动态')
      }
    }
  }, [_vm._v("新闻动态")])]), _vm._v(" "), _c('div', {
    staticClass: "page-bottom-hor-split"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _vm._m(11)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.curIdx !== 6),
      expression: "config.curIdx !== 6"
    }],
    staticClass: "next-button",
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._m(12)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topImage"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": require("@/assets/mainlogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topRight1"
  }, [_c('div', {
    staticClass: "topRight1T"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("业务咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "topRight1B"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("0536-8812347")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "float": "right",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("@/assets/topphone.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainOneC"
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("@/assets/oneLeft.png")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "float": "right",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("@/assets/oneRight.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen-2 screenItem"
  }, [_c('div', {
    staticClass: "intro-img-container"
  }, [_c('img', {
    staticClass: "intro-img",
    attrs: {
      "src": require("@/assets/gw_intro1.png"),
      "alt": "",
      "id": "move1"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen-3 screenItem"
  }, [_c('div', {
    staticClass: "intro-img-container"
  }, [_c('img', {
    staticClass: "intro-img",
    attrs: {
      "src": require("@/assets/gw_intro2.png"),
      "alt": "",
      "id": "move2"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-title"
  }, [_c('img', {
    staticClass: "product-title-img",
    attrs: {
      "src": require("@/assets/product_title.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen-5 screenItem"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "product-title"
  }, [_c('img', {
    staticClass: "product-title-img",
    attrs: {
      "src": require("@/assets/gw_cooperation.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-content-container"
  }, [_c('div', {
    staticClass: "product-content clearfix"
  }, [_c('img', {
    staticClass: "cooperation-content-img",
    attrs: {
      "src": require("@/assets/gw_coopera_company.png"),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-left"
  }, [_c('img', {
    staticClass: "page-bottom-left-logo",
    attrs: {
      "src": require("@/assets/mainlogo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("公司致力于智慧城市便民服务体系建设和运营，以“V派”城市通行证手机APP为载体，依托云计算、物联网、大数据应用和“互联网+”技术，以创建全国智慧城市样板为目标，逐步提升城市公共服务水平和居民生活品质。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_address_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("山东省潍坊市奎文区恒易宝莲金融中心A座1902")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_tel_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("0536-8812347")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_mail_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("icloudpay@icloudpay.net.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-right-code-container"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": require("@/assets/gw_qrcode.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("扫一扫关注我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottomcenter"
  }, [_c('img', {
    staticStyle: {
      "height": "20px",
      "width": "20px",
      "margin-left": "20px"
    },
    attrs: {
      "src": require("@/assets/arraw.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-82029f60"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Guanwang/MainPage.vue
// module id = 296
// module chunks = 1